import { Error } from '@styled-icons/material';
import React, { useContext } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PopupNotice from '../../sharedComponents/PopupNotice';
import { TextEditorContext } from '../../sharedComponents/TextEditor/context/TextEditorContext';
import styles from '../../styles/Home.module.css';
import Button from '../../sharedComponents/Button';
import { useSaveContentMutation, useSaveNavbarMutation } from '../../store';
import { useSpaceAndPageIDFromRouter } from '../../data/space/hooks';
import { errToString } from '../../utils/errors';

export default function OverwritePopupNotice({ save }: {
  save?: (force: boolean) => void;
}) {
  const router = useRouter();
  const [spaceID, pageID] = useSpaceAndPageIDFromRouter();
  const { save: legacySave } = useContext(TextEditorContext);
  const {
    isLoading: loadingSaveContent,
    error: errorSaveContent,
    reset: resetSaveContent,
  } = useSaveContentMutation({ fixedCacheKey: `saveContent-${pageID}` });
  const {
    isLoading: loadingSaveNavbar,
    error: errorSaveNavbar,
    reset: resetSaveNavbar,
  } = useSaveNavbarMutation({ fixedCacheKey: `saveNavbar-${spaceID}` });

  const stringErrorSaveContent = errorSaveContent ? errToString(errorSaveContent) : '';

  const stringErrorSaveNavbar = errorSaveNavbar ? errToString(errorSaveNavbar) : '';

  return (
    <PopupNotice
      bottom
      right
      className="with-text-color"
      icon={<Error size={20} className="with-danger-text-color" />}
      open={!!(errorSaveContent || errorSaveNavbar)}
      onClose={() => {
        resetSaveContent();
        resetSaveNavbar();
      }}
    >
      {stringErrorSaveContent.includes('modified') || stringErrorSaveNavbar.includes('modified') ? (
        <div className={styles.content}>
          <div className="mb-4 with-text-color">
            This page has been modified by others
          </div>
          <div
            className={classNames(
              styles.blockItem,
              'is-flex is-flex-direction-row is-align-items-center',
            )}
          >
            <Button
              className={classNames({
                'button is-loading': loadingSaveContent || loadingSaveNavbar,
              })}
              onClick={
                loadingSaveContent || loadingSaveNavbar
                  ? () => null
                  : () => (legacySave ? legacySave(true) : save(true))
              }
            >
              Use my changes
            </Button>
            <div
              className="is-subtitle ml-4 has-text-weight-normal"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                router.reload();
              }}
              role="none"
            >
              Discard draft
            </div>
          </div>
        </div>
      ) : (
        <>
          {stringErrorSaveContent}
          {' '}
          {stringErrorSaveNavbar}
        </>
      )}
    </PopupNotice>
  );
}

OverwritePopupNotice.defaultProps = {
  save: undefined,
};
